"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRules = void 0;
const standard_1 = require("./standard");
const roro_1 = require("./roro");
const getRules = (rulesName) => {
    switch (rulesName) {
        case 'standard':
            return standard_1.standardRules;
        case 'roro':
            return roro_1.roroRules;
    }
};
exports.getRules = getRules;
